import axios from "axios";

const api = axios.create({
    baseURL: "https://sms.brightechsoftware.com", // 🔥 change here only
    headers: {
        "Content-Type": "application/json",
    },
});

export default api;